@if (true) {
<div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
        <div class="modal-content">
            <div class="modal-header BlueHeader">
                <h4 class="Heading">{{ModelFor}}</h4><br>
                <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()"
                    data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body  col-sm-12 form-group">
                <iframe width="100%" Height="400 px" [src]="modalURL|safe"></iframe>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="table-header-container">
        <div class="table-heading">
            Email Log
        </div>
        <form  [formGroup]="FormSearchEmailLog"
            (ngSubmit)="onSearchEmailLog(FormSearchEmailLog.value)">
            <div class="d-flex">
                <div class="input-group">
                    <input type="text" placeholder="Search here..." class="table-search-input form-control"
                    formControlName="txtSearch">
                    <span class="input-group-btn">
                    <button class="btn btn-primary" title="Search">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                    </span>
              </div>
            </div>
        </form>
    </div>
    <div class="card table-container">
        <table class="custom-table">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Mail Type</th>
                    <th>Email ID</th>
                    <th>Subject</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <app-table-state [loading]="MsgType == 1"
                    [error]="MsgType == 3 ? 'Something went wrong while fetching data.' : null" [empty]="MsgType == 2"
                    [rows]="10" [columns]="5">
                </app-table-state>
                @if (MsgType == 0 && master.length > 0) {
                @for (mDtl of filteredData | paginate: { itemsPerPage: pageSize, currentPage: pageNumber }; track $index; let i =
                $index) {
                <tr>
                    <td> {{mDtl.recAddDate|date:'dd-MMM-yyyy hh:mm:ss a'}} </td>
                    <td> {{mDtl.Mail_Type}} </td>
                    <td> {{mDtl.EmailID}} </td>
                    <td> {{mDtl.Subject}} </td>
                    <td> {{mDtl.Status}} </td>
                </tr>
                }

                }
            </tbody>
        </table>
    </div>
    @if (filteredData?.length > 0) {
        <div class="d-flex justify-content-between my-3 w-100">
            <div class="w-50">
                <app-rows-per-page
                [pageSize]="pageSize"
                [total]="totalRecords"
                [pageIndex]="pageNumber"
                (pageSizeChange)="onPageSizeChange($event)">
            </app-rows-per-page>
            </div>
            <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
        </div>
    }
</div>
}@else {
<!-- <my-content placeholder="navigation">

    <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>

    <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog-FactSheet">
            <div class="modal-content">
                <div class="modal-header BlueHeader">
                    <h4 class="Heading">{{ModelFor}}</h4><br>
                    <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()"
                        data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body  col-sm-12 form-group">
                    <iframe width="100%" Height="400 px" [src]="modalURL|safe"></iframe>
                </div>
            </div>
        </div>
    </div>


    <div class="col-sm-12" style="margin-top: 8px;">
        <div class=" col-sm-12 lefticonD paddingless"
            style="border-left:1px solid #ccc;border-top:1px solid #ccc; border-right:1px solid #ccc;">
            <label>Email Log </label>
        </div>
        <table width="100%" class="LMtable">
            <tr>
                <th>Date</th>
                <th>Mail Type</th>
                <th>Email ID</th>
                <th>Subject</th>
                <th>Status</th>
            </tr>

            <tr *ngIf="this.MsgType == 1">
                <td colspan="80">
                    <div class="d-flex align-items-center">
                        <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                        <div class="spinner-border" role="status"></div>
                    </div>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 2">
                <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                    <span>{{DisplayMessage}}</span>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 3">
                <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                </td>
            </tr>
            <ng-container *ngIf="this.MsgType == 0">
                <tr *ngFor="let mDtl of master | paginate: { itemsPerPage: 10, currentPage: pageNumber }; let i=index">
                    <td> {{mDtl.recAddDate|date:'dd-MMM-yyyy hh:mm:ss a'}} </td>
                    <td> {{mDtl.Mail_Type}} </td>
                    <td> {{mDtl.EmailID}} </td>
                    <td> {{mDtl.Subject}} </td>
                    <td> {{mDtl.Status}} </td>
                </tr>
            </ng-container>
        </table>
        <br>

        <ng-container *ngIf="this.MsgType == 0">
            <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
        </ng-container>

    </div>


    <div><br>&nbsp;</div>



</my-content>
<my-content placeholder="main">

</my-content> -->
}